// src/sections/Drinks/Drinks.js
import React from 'react';
import styles from './Drinks.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const drinksData = {
  // CORRIGÉ : Catégorie renommée de "freez" à "refreshRestart" pour correspondre au menu
  refreshRestart: [
    { id: "drink-refresh-blue-hawaii", name: "BLUE HAWAÏ", price: "3.00€" },
    { id: "drink-refresh-pina-colada", name: "PIÑA COLADA", price: "3.00€" },
    { id: "drink-refresh-mojito", name: "MOJITO", price: "3.00€" },
    { id: "drink-refresh-grenadine", name: "GRENADINE", price: "3.00€" },
    { id: "drink-refresh-kiwi-citron", name: "KIWI CITRON VERT", price: "3.00€" },
    { id: "drink-refresh-citron-gingembre", name: "CITRON GINGEMBRE", price: "3.00€" },
    { id: "drink-refresh-mangue-peche", name: "MANGUE PÊCHE", price: "3.00€" },
    { id: "drink-refresh-pomme-raisin", name: "POMME RAISIN", price: "3.00€" },
  ],
  moguMogu: [
    { id: "drink-mogu-litchi", name: "LITCHI", price: "3.00€" },
    { id: "drink-mogu-pasteque", name: "PASTÈQUE", price: "3.00€" },
    { id: "drink-mogu-mangue", name: "MANGUE", price: "3.00€" },
    { id: "drink-mogu-ananas", name: "ANANAS", price: "3.00€" },
    { id: "drink-mogu-framboise", name: "FRAMBOISE", price: "3.00€" },
    { id: "drink-mogu-melon", name: "MELON", price: "3.00€" },
    { id: "drink-mogu-peche", name: "PÊCHE", price: "3.00€" },
  ],
  // CORRIGÉ : Ajout des boissons manquantes, correction de prix et réorganisation
  sodasEaux: [
    { id: "drink-icetea", name: "ICE TEA PÊCHE (33 CL)", price: "2.50€" },
    { id: "drink-orangina", name: "ORANGINA (33 CL)", price: "2.50€" },
    { id: "drink-coca", name: "COCA-COLA (33 CL)", price: "2.50€" },
    { id: "drink-coca-zero", name: "COCA-COLA ZÉRO (33 CL)", price: "2.50€" },
    { id: "drink-cristaline-50", name: "CRISTALINE (50 CL)", price: "1.50€" },
    { id: "drink-cristaline-gazeuse", name: "CRISTALINE GAZEUSE (50 CL)", price: "2.50€" }, // Prix corrigé
  ]
};

const Drinks = ({ id, favorites, addFavorite, removeFavorite }) => {
  
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.drinks}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>BOISSONS</h2>

        <div className={styles.drinksGrid}>
          {/* CORRIGÉ : Colonne renommée et mise à jour pour utiliser "refreshRestart" */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>REFRESH RESTART</h3>
            {drinksData.refreshRestart.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Colonne Mogu Mogu */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>MOGU MOGU</h3>
            {drinksData.moguMogu.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Colonne Sodas - Eaux */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>SODAS - EAUX</h3>
            {drinksData.sodasEaux.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Drinks;